module.exports = "/_next/static/images/up-661e9b2075beafeca8223d42d165ac73.svg";